import {
  FAIcon,
  GenericLink,
  IconStyle,
  Tag,
  TagStyle,
  TagWidth,
  Theme,
  useSession,
  useTranslation,
  NextgenImage,
} from '@nextgen-web-framework/all';
import { ConfigService } from '@nextgen-web-framework/core';
import { UrlKeyEnum } from '../../utils/common';
import styles from './MyAccountSection.module.scss';
import { MyAccountSectionProps } from './type/propsTypes';

const MyAccountSection = (props: MyAccountSectionProps) => {
  const t = useTranslation();
  const { session } = useSession();
  const { primaryProfile } = session;
  const tagTitle = primaryProfile ? 'coapplicant' : 'primary';
  const configs = ConfigService.getConfigs();
  const ASSETS_BASE_PATH = configs.NEXT_ASSETS_BASE_PATH;

  return (
    <GenericLink href={`/my-account/${props.sectionData.link.url}`} className={styles['my-account-link']}>
      <div
        className={styles['user-account-card']}
        key={`${props.sectionData.title}`}
        data-testid="user-account-card-testid"
      >
        <div className={styles['user-account-icon']}>
          <FAIcon theme={Theme.PURPLE} iconName={props.sectionData.iconName} iconStyle={IconStyle.REGULAR} />
        </div>
        <div className={styles['user-account-card-details']}>
          <div className={styles['user-account-card-heading']}>
            <h2>{props.sectionData.title}</h2>{' '}
            {props.sectionData.link.url === UrlKeyEnum.CO_APPLICANT && (
              <div>
                <Tag
                  style={TagStyle.SOLID}
                  tagWidth={TagWidth.FULL_WIDTH}
                  text={t(`web.tag.${tagTitle}`)}
                  theme={Theme.PURPLE}
                  data-testid="owner-tag"
                />
              </div>
            )}
            {props.sectionData.link.url?.includes(UrlKeyEnum.ACCOUNT_RENEWAL) && props.isExclamation && (
              <div className={styles['user-account-exclamation']}>
                <NextgenImage src={`${ASSETS_BASE_PATH}/icons/triangle-exclamation.svg`} alt={''} />
              </div>
            )}
          </div>
          <h6>{props.sectionData.subTitle}</h6>
        </div>
      </div>
    </GenericLink>
  );
};
export default MyAccountSection;
